<template>
  <div class="lby-propagandize">
    <img :src="logo">
    <p class="propaganda-text top">试运营阶段，网站服务完全免费 本网站宗旨，以更低的价格，提供更好的服务</p>
    <router-link class="propaganda-text bottom" to="/donate">网站运营需要资金，期望各位亲们能捐赠点资金，维持网站的日常运营，本司不胜感激😭</router-link>
    <p class="welcome">欢迎来到MY聚宝阁，MY聚宝阁，有您更精彩^-^</p>
    <p class="visitor">24小时内访客数量:{{visitorCount}}</p>
    <div class="company-name">梦想起航网络科技</div>
    <div class="company-name download-center"><a href="https://static-mp-14f24e9c-20b1-41f3-972c-6827949fcf56.next.bspapp.com/portal.html" target="_blank" rel="noopener noreferrer">应用下载中心</a></div>
  </div>
</template>

<script>
import { getVisitorCount } from '@/api/systeminfos'
import logo from '@/assets/lotterycenter.png'
export default {
  name: 'MyPropagandize',
  data () {
    return {
      logo,
      visitorCount: 0
    }
  },
  async created () {
    const res = await getVisitorCount()
    if (res.code !== 1) {
      this.visitorCount = 0
    }
    this.visitorCount = res.data
  }
}
</script>

<style scoped lang="less">
.lby-propagandize{

    width: 1080px;
    height: 150px;
    margin: 30px auto;
    position: relative;
    .company-name{
      position: absolute;
      width: fit-content;
      padding-left: 10px;
      padding-right: 10px;
      padding-bottom: 5px;
      padding-top: 2px;
      font-size: 15px;
      top: -9px;
      right: 48px;
      background-color: rgb(255, 166, 0);
      color: white;
      backdrop-filter: blur(20rpx);
      border-radius: 10px 10px 0 0;
    }
    .download-center{
      left: 108px;
      background-color:#54539b;
      width: 100px;
      height:25px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-overflow: clip;
      a{
        display: inline-block;
        background-color: transparent;
        text-decoration: none;
        color: white;
        height:25px;
      }
    }
    .download-center:hover{
      font-size: 16px;
    }
    .welcome{
      position: absolute;
      font-size: 30px;
      z-index: 20;
      color: rgb(230, 44, 44);
      font-weight: bold;
      right: 0;
      left: 0;
      margin: 0 auto;
      top:50px;
      letter-spacing: 3px;
      background: rgba(0, 0, 0, 0.2);
      backdrop-filter: blur(20rpx);
      border-radius: 20px;
      width: 750px;
      box-shadow:  0 0 5px rgb(126, 126, 126);
      cursor: default;
    }
    .visitor{
      font-size: 15px;
      position: absolute;
      z-index: 20;
      right: 25px;
      bottom: 15px;
      width: fit-content;
      padding: 0 10px;
      color: white;
    }
    .welcome:hover{
      color: rgb(255, 50, 50);
      box-shadow:  0 0 7px rgb(255, 255, 255);
    }
    .propaganda-text{
      position: absolute;
      z-index: 20;
      left: 0;
      right: 0;
      margin: auto;
      width: fit-content;
      top: 10px;
      color: white;
    }
    .top{
      top: -20px;
      color: red;
    }
    .bottom{
      top: -5px;
      color: red;
      height: 15px;
    }
    img{
      position: absolute;
      width: 100%;
      z-index: 10;
      height: 260px;
      left: 0;
      pointer-events: none;
    }
    a{
      position: absolute;
      width: 98%;
      height: 150px;
      display: block;
      z-index: 20;
      left:1%;
      top:1%;
    }
}
</style>
